export default function(graph) {
	const values = { labels: [], amount: [], mileage: [] };
	for (const keyGraph in graph) {
		const { amount, mileage } = graph[keyGraph];

		values.labels.push(keyGraph);
		values.amount.push(amount);
		values.mileage.push(mileage);
	}

	return values;
}
